import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/base";
import dotenv from "dotenv";
dotenv.config();
import { store } from "./store/main";
import Constants from "./constants/Constants";
import VueScrollTo from "vue-scrollto";
import "./css/main.css";
import AOS from "aos";
import "aos/dist/aos.css";
import VueLazyload from "vue-lazyload";
import i18n from "./i18n";
import moment from "moment";

Vue.use(VueLazyload);

Vue.use(VueScrollTo, {
  cancelable: false,
  offset: -50,
  force: false,
});

Vue.config.productionTip = false;

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).locale();
  }
});

const main = new Vue({
  el: "#app",
  vuetify,
  store,
  Constants,
  created() {
    AOS.init();
  },
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default main;
